<template>
  <div>
    <vue-editor id="editor"
      v-model="updatedText"
      :editorToolbar="customToolbar"
      useCustomImageHandler
      @imageAdded="handleImageAdded"
      v-if="editorMode==='rich'">
    </vue-editor>
    <div class="form-group" v-if="editorMode==='html'">
      <textarea class="form-control" rows="17" v-model="updatedText"></textarea>
    </div>
    <br>
    <div class="html-mode-section">
      <c-switch class="mx-1" color="primary" label variant="pill" name="switch1" v-model="editorMode" value="html" uncheckedValue="rich"/> 
      <span> HTML editor mode</span>
    </div>
  </div>
</template>

<script>
import { VueEditor, Quill  } from "vue2-editor"
import videoBlot from '@/shared/videoBlot'
import Helper from '@/shared/helper'
import { Switch as cSwitch } from '@coreui/vue'
const Image = Quill.import('formats/image');
Image.className = 'img-fluid';

Quill.register(videoBlot)
Quill.register(Image, true);

export default {
  name: 'richEditor',
  props: ['value'],
  components: { 
    VueEditor,
    cSwitch
  },
  mixins: [Helper],
  data() {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'color': [] }], 
        [{ 'align': [] }],
        ['clean'], 
        ['link', 'image', 'video']
      ],
      updatedText: this.value,
      editorMode: 'rich'
    }
  },
  watch: {
    updatedText(newValue) {
      this.$emit('input', newValue)
    },
    value(newValue) {
      this.updatedText = newValue
    }
  }
}
</script>

<style lang="scss">
  .html-mode-section {
    span {

    }
    * {
      vertical-align: middle;
    }
  }
</style>